import React from 'react';
import EventListner from './EventListner';

const Viewport = () => <EventListner />;

export default Viewport;
